class Scrollspy {
  constructor(onSectionsUpdate) {
    this.init();
  }

  init() {
    const scrollSpyTitles = document.querySelectorAll(".scrollspy-title");
    const scrollspyList = document.querySelector(".scrollspy-list");
    // const navbarHeight = document.querySelector(".iz-header").offsetHeight;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
              document.querySelectorAll(".scrollspy-list li a").forEach((el) => {
                  el.classList.remove("active");
              });
              document.querySelector(`.scrollspy-list .${entry.target.id}`).classList.add("active");
          }
        });
      },
      {
        threshold: 0.5
      }
    );

    scrollSpyTitles.forEach((item, i) => {
      const li = document.createElement("li")
      const a = document.createElement("a");

      a.href = `#section-${i + 1}`;
      item.closest(".scrollspy-container-wrapper").id = `section-${i + 1}`;
      a.innerHTML = i + 1;
      a.classList.add(`section-${i + 1}`);
      a.dataset.hover = item.innerHTML;

      li.appendChild(a)
      scrollspyList.appendChild(li)
      observer.observe(item.closest(".scrollspy-container-wrapper"))
    })

    document.querySelectorAll(".scrollspy-list a").forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = anchor.getAttribute('href').substring(1);
          const targetSection = document.getElementById(targetId);

          window.scrollTo({
            top: targetSection.offsetTop,
            behavior: 'smooth'
          });
      });
    });
  }
}


export default Scrollspy;

 //class Scrollspy {
//   constructor(onSectionsUpdate) {
//     this.sections = [];
//     this.observer = null;
//     this.onSectionsUpdate = onSectionsUpdate;
//     this.init();
//   }



//   init() {
//     const spanElements = document.querySelectorAll(".scrollspy-title");

//     spanElements.forEach((span) => {
//       const text = span.textContent.trim();
//       if (text) {
//         const id = text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-_]/g, "");
//         span.id = id;
//         span.setAttribute("data-hover", text);
//       }
//     });

//     const sectionElements = document.querySelectorAll("[id]");
//     this.sections = Array.from(sectionElements).map((section, index) => ({
//       id: section.id,
//       label: section.getAttribute("data-hover") || section.textContent.trim(),
//       number: index + 1,
//     }));

//     // Call the Vue callback with updated sections
//     if (this.onSectionsUpdate) {
//       this.onSectionsUpdate(this.sections);
//     }
//   }
// }


// class Scrollspy {
//   constructor(sectionsRef) {
//     this.sectionsRef = sectionsRef; // Reactive reference to sections
//     this.init();
//   }

//   // Rename 'value' method to 'setValue'
//   setValue(newValue) {
//     if (typeof this.value === 'undefined') {
//       this.value = {}; // Ensure 'value' exists
//     }
//     this.value = newValue;
//   }

//   init() {
//     // Process all elements with the scrollspy-title class
//     const spanElements = document.querySelectorAll(".scrollspy-title");
//     spanElements.forEach((span) => {
//       const text = span.textContent.trim();
//       if (text) {
//         const id = text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-_]/g, "");
//         span.id = id;
//         span.setAttribute("data-hover", text);
//       }
//     });

//     // Collect all sections (include both IDs and the scrollspy titles in the ul)
//     const sectionElements = document.querySelectorAll(".scrollspy-title, ul.scrollspy [id]");
//     const newSections = Array.from(sectionElements).map((section, index) => ({
//       id: section.id,
//       label: section.getAttribute("data-hover") || section.textContent.trim(),
//       number: index + 1,
//     }));

//     // Update the reactive reference
//     this.sectionsRef.value = newSections;
//   }
// }

// export default Scrollspy;




// class Scrollspy {
//   constructor() {

//     const sections = document.querySelectorAll('[id^="section"]');
//     if (sections.length === 0) return;

//       const observer = new IntersectionObserver(
//         (entries) => {
//           entries.forEach(entry => {
//             if (entry.isIntersecting) {
//                 document.querySelectorAll(".scrollspy li a").forEach((el) => {
//                     el.classList.remove("active");
//                 });
//                 document.querySelector(`.scrollspy .${entry.target.id}`).classList.add("active");
//             }
//           });
//         },
//         {
//           threshold: 0.3,
//         }
//       );

//       sections.forEach(section => observer.observe(section));

//   }
// }

// export default Scrollspy;

